import { ref } from 'vue';

export const STATES = {
  IDLE: 'IDLE',
  RESOLVING_INPUTS: 'RESOLVING_INPUTS',
  EXECUTION_SELECTION: 'EXECUTION_SELECTION',
  MAPPING_ERROR: 'MAPPING_ERROR',
  INPUT_FORM: 'INPUT_FORM',
  EXECUTING: 'EXECUTING',
  AWAITING_SELECTION: 'AWAITING_SELECTION',
  RESULTS: 'RESULTS',
  DOCUMENT_CREATION_STATUS: 'DOCUMENT_CREATION_STATUS'
};

const TRANSITIONS = {
  IDLE:                       ['RESOLVING_INPUTS'],
  RESOLVING_INPUTS:           ['EXECUTION_SELECTION', 'MAPPING_ERROR', 'INPUT_FORM', 'EXECUTING'],
  EXECUTION_SELECTION:        ['RESOLVING_INPUTS', 'RESULTS'],
  MAPPING_ERROR:              ['RESOLVING_INPUTS'],
  INPUT_FORM:                 ['EXECUTING'],
  EXECUTING:                  ['RESULTS', 'AWAITING_SELECTION'],
  AWAITING_SELECTION:         ['EXECUTING', 'RESULTS'],
  RESULTS:                    ['INPUT_FORM', 'EXECUTION_SELECTION', 'EXECUTING', 'DOCUMENT_CREATION_STATUS'],
  DOCUMENT_CREATION_STATUS:   ['RESULTS']
};

export function useChainStateMachine() {
  const self = {
    currentState: ref(STATES.IDLE),
    previousState: ref(null),
    STATES,
  };

  self.transition = (to) => {
    const allowed = TRANSITIONS[self.currentState.value] || [];
    if (!allowed.includes(to)) {
      console.warn(`Invalid transition: ${self.currentState.value} → ${to}`);
      return false;
    }
    self.previousState.value = self.currentState.value;
    self.currentState.value = to;
    return true;
  };

  self.forceState = (to) => {
    self.previousState.value = self.currentState.value;
    self.currentState.value = to;
  };

  return self;
}
